import dayjs from "dayjs";

export const EventInvitation = (
  user: any,
  firm: any,
  theCase: any,
  referral: any,
  provider: any,
  resource: any,
  event: any
) => {
  const htmlbody = `
  <!DOCTYPE html>
  <html lang="en">
  <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Email Template</title>
  </head>
  <body>
    <div class="email-container" style="background-color:rgb(229, 229, 229); width:100%;">
        <div class="content-container" style="width:90%;background-color:rgb(255, 255, 255);margin-top:20px;margin-bottom:20px;margin-left:auto;margin-right:auto;">
            <!-- Header Section with Thrive Logo -->
            <div class="header" style="margin:20px;background-color:#9d2362;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;width:100%;background-color:#9d2362;">
                    <tbody>
                        <tr>
                            <td style="width:96px;height:60px;background-color:#9d2362;">
                                <img alt="Thrive Logo" src="https://www.thrive-drive.org:8443/images/Thrive_logo.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:96px;height:43px;font-size:13px;" title="Thrive Logo" width="140">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Content Section -->
            <div class="content" contenteditable="true" style="margin:20px;" role="replace">
                <p><strong>Hello,</strong></p>
                <p>I want to invite you to an upcoming Thrive training event. Please find the registration link and event details below.</p>
                <p><a href="${event.url}">${event.url}</a></p>
                <p><a href="${
                  event.url
                }"><button style="background-color: #9D2362; color: white; font-size: 16px; padding: 5px; outline: none; border-radius: 5px; cursor: pointer;">Event Invitation</button></a></p>
            </div>

            <!-- Event Details Section -->
            <div class="event-details" style="margin:20px;">
                <p style="Margin:0;text-align:center;mso-line-height-alt:28px;mso-ansi-font-size:24px;"><span style="font-size:20px;font-family:Inter,Arial,sans-serif;font-weight:700;color:#000000;line-height:113%;mso-line-height-alt:28px;mso-ansi-font-size:24px;">${
                  event.name.text
                }</span></p>
                <img alt src="${
                  event.logo ? event.logo.url : ""
                }" style="margin:auto;border:0;display:block;outline:none;text-decoration:none;height:auto;width:75%;font-size:13px;" title width="150" height="auto">
                <p></p>
                <p style="Margin:0;text-align:center;mso-line-height-alt:16px;mso-ansi-font-size:14px;"><span style="font-size:16px;font-family:Inter,Arial,sans-serif;font-weight:400;color:#000000;line-height:100%;mso-line-height-alt:16px;mso-ansi-font-size:14px;">${
                  event.locationInfo.localized_address_display
                }</span></p>
                <p style="Margin:0;text-align:center;mso-line-height-alt:16px;mso-ansi-font-size:14px;"><span style="font-size:16px;font-family:Inter,Arial,sans-serif;font-weight:400;color:#000000;line-height:100%;mso-line-height-alt:16px;mso-ansi-font-size:14px;">${
                  dayjs(event.start.local).format("YYYY-MM-DD h:mm A") +
                  " - " +
                  dayjs(event.end.local).format("h:mm A")
                }</span></p>
            </div>
             
            <!-- SBC Signature Section -->
            <div class="sbc-signature" style="margin:20px;">
                <p>Additional information is available, if needed. Please let me know if you have questions.</p>
                <p style="margin: 0; font-size: 16px; color: #333333; line-height: 1.6;">
                  Kindest Regards,
                </p>
                <p style="margin: 0 0 10px 0; font-size: 16px; color: #333333; line-height: 1.6;">
                    <strong>${user.firstName} ${user.lastName}</strong>
                </p>
                <p>
                    <em>${user.title}</em>
                </p>
                <p style="margin:0 0 5px 0;">
                    <a href="tel:${
                      user.phone
                    }" style="color: #007bff; text-decoration: none;">${
    user.phone
  }</a>
                </p>
                <p style="margin:0 0 5px 0;">
                    <a href="mailto:${
                      user.email
                    }" style="color: #007bff; text-decoration: none;">${
    user.email
  }</a>
                </p>
                <a href="${
                  user.meeting_url
                    ? user.meeting_url
                    : "https://outlook.office365.com/owa/calendar/OaklandThriveClintMeetingPage@NETORGFT13100098.onmicrosoft.com/bookings/"
                }">Click to Schedule Your Consultation!</a>
            </div>

            <!-- Footer Section -->
            <div class="footer" style="padding:20px; background-color:#f8f9fa; text-align:center;">
                <div class="social-links" style="width:100%;margin:0 auto;text-align:left;">
                    <a href="https://www.facebook.com/oaklandthrive" style="display:inline-block; margin:0 10px; color:#9d2362; text-decoration:none;">
                        <img src="https://cdn-icons-png.flaticon.com/512/733/733547.png" alt="Facebook" width="24" style="width:24px; max-width:100%; height:24px; vertical-align:middle; margin-right:5px;">
                    </a>
                    <a href="https://x.com/OaklandThrive" style="display:inline-block; margin:0 10px; color:#9d2362; text-decoration:none;">
                        <img src="https://cdn.gifo.wisestamp.com/s/tw/55acee/48/0/background.png" alt="X" width="24" style="width:24px; max-width:100%; height:24px; vertical-align:middle; margin-right:5px;">
                    </a>
                    <a href="https://www.linkedin.com/company/oakland-thrive" style="display:inline-block; margin:0 10px; color:#9d2362; text-decoration:none;">
                        <img src="https://cdn-icons-png.flaticon.com/512/733/733561.png" alt="LinkedIn" width="24" style="width:24px; max-width:100%; height:24px; vertical-align:middle; margin-right:5px;">
                    </a>
                    <a href="https://www.instagram.com/oaklandthrive/" style="display:inline-block; margin:0 10px; color:#9d2362; text-decoration:none;">
                        <img src="https://cdn-icons-png.flaticon.com/512/733/733558.png" alt="Instagram" width="24" style="width:24px; max-width:100%; height:24px; vertical-align:middle; margin-right:5px;">
                    </a>
                </div>
                
                <p style="color:#666666; font-size:14px; margin:5px 0;"><strong>Oakland Thrive</strong></p>
                <p style="color:#666666; font-size:14px; margin:5px 0;">35 W Huron St., Suite 201 Pontiac, MI 48342</p>
                
                <p style="color:#666666; font-size:14px; margin:5px 0;">© 2025 Oakland Thrive. All rights reserved.</p>
                
                <p style="color:#666666; font-size:14px; margin:5px 0;">
                    <a href="https://www.thrive-drive.org/unsubscribe/replacewithfirmid" style="color:#9d2362; text-decoration:none;">Unsubscribe</a>
                </p>
            </div>
        </div>
    </div>
  </body>
</html>
`;
  return htmlbody;
};
